import { render, staticRenderFns } from "./FilesUploadArea.vue?vue&type=template&id=8d54872a&scoped=true&"
import script from "./FilesUploadArea.vue?vue&type=script&lang=js&"
export * from "./FilesUploadArea.vue?vue&type=script&lang=js&"
import style0 from "./FilesUploadArea.vue?vue&type=style&index=0&id=8d54872a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d54872a",
  null
  
)

export default component.exports